// material-ui
import {} from '@mui/material'
import React from 'react'
import { useParams } from 'react-router-dom'

import * as applicationSlice from 'features/application/application-slice'
import { SNACKBAR_OPEN } from 'store/actions'
import TitleService from 'title-service'

// assets
import * as autoThunks from 'features/auto-thunks'
import { useEffect } from 'react'

import EditProfile from 'components/EditProfile'
import ProfileHeader from 'components/ProfileHeader'
import ProfileScene from 'components/ProfileScene'
import { getUserClaims } from 'features/application/application-slice'
import {
  get_selected_profile,
  setSelectedprofile,
} from 'features/profile/profile-slice'
import { useDispatch, useSelector } from 'react-redux'

// ================================|| UI LIST - SIMPLE LIST ||================================ //

export default function SimpleList() {
  // Generate Grid
  const params = useParams()
  let dispatch = useDispatch()
  let claims = useSelector(getUserClaims)
  let profile = useSelector(get_selected_profile)
  const [contextId, setContextId] = React.useState(null)
  const [saveArgs, setSaveArgs] = React.useState(null)

  useEffect(() => {
    if (claims?.user && params?.id) {
      dispatch(
        autoThunks.get_profile({
          profileId: (() => {
            function getProfileId(): any {
              return params?.id
            }
            return getProfileId()
          })(),
          userId: claims?.fire_user,
        }),
      )
    }
  }, [claims?.user, params?.id])
  useEffect(() => {
    if (claims?.user && params?.id) {
      function set_current_profile(): any {
        return dispatch(setSelectedprofile(params?.id))
      }
      set_current_profile()
    }
  }, [claims?.user, params?.id])
  useEffect(() => {
    if (claims?.user && saveArgs?.profileName && saveArgs?.profileImage) {
      dispatch(
        autoThunks.update_profile({
          profileId: (() => {
            function getProfileId(): any {
              return params?.id
            }
            return getProfileId()
          })(),
          profileArgs: (() => {
            function getSaveArgs(): any {
              return saveArgs
            }
            return getSaveArgs()
          })(),
          userId: claims?.fire_user,
          callback: (success: boolean, res: any) => {
            if (success) {
              updateCurrentProfileMaybe(success, res)
            } else {
              failedToUpdate()
            }
          },
        }),
      )
    }
  }, [
    claims?.user,
    saveArgs?.profileName,
    saveArgs?.profileImage,
    saveArgs?.isChild,
    saveArgs?.dateOfBirth,
  ])

  function updateCurrentProfileMaybe(success: boolean, res: any): any {
    if (res && res.data) {
      let { data } = res
      let profileId = params?.id
      if (profileId === data?.id) {
        dispatch(applicationSlice.setProfileImage(data.profileImage))
        dispatch(applicationSlice.setProfileName(data.name))
        dispatch({
          type: SNACKBAR_OPEN,
          open: true,
          message: TitleService(`Profile updated`),
          variant: 'alert',
          alertSeverity: 'success',
        })
      }
    }
  }

  function main(comp: any): any {
    return (() => {
      return (
        <div className="profile component">
          <ProfileScene>
            <ProfileHeader
              btnTitle={TitleService('Done')}
              onBtnClick={() => {
                history.back()
              }}
            ></ProfileHeader>
            <EditProfile
              profile={profile}
              onChange={(args: any) => {
                setSaveArgs({ profileName: args.name, ...args })
              }}
            />
          </ProfileScene>
        </div>
      )
    })()
  }

  let output_main = main(null)

  return output_main
}
